DJ.addBehavior('js-hidden-text-mobile', '.js-hidden-text-mobile', {
  attach: function (context, settings, behavior) {
    jQuery('.js-hidden-text-mobile').each(function () {
      var innerHeight = jQuery(this).find('.content-text__inner').height();
      if (innerHeight > 205) {
        jQuery(this).find('.js-toggle-text-btn').removeClass('hidden');
      }
    });
    jQuery(this).find('.js-toggle-text-btn').click(function (e) {
      e.preventDefault();
      var openText = jQuery(this).attr('data-open-text');
      var closeText = jQuery(this).attr('data-hide-text');
      var textBlock = jQuery(this).closest('.js-hidden-text-mobile').find('.js-content-text');
      if (textBlock.is('.opened')) {
        textBlock.removeClass('opened');
        jQuery(this).find('.js-text').html(openText);
        jQuery(this).attr('aria-expanded', 'false');
      } else {
        textBlock.addClass('opened');
        jQuery(this).find('.js-text').html(closeText);
        jQuery(this).attr('aria-expanded', 'true');
      }
    });
  },

  detach: function (context, settings) {
  }
});
